module.exports = __webpack_public_path__ + "img/logo-the1.357919b9.svg";